import { render, staticRenderFns } from "./ProductNine.vue?vue&type=template&id=65178c3a&"
import script from "./ProductNine.vue?vue&type=script&lang=js&"
export * from "./ProductNine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65178c3a')) {
      api.createRecord('65178c3a', component.options)
    } else {
      api.reload('65178c3a', component.options)
    }
    module.hot.accept("./ProductNine.vue?vue&type=template&id=65178c3a&", function () {
      api.rerender('65178c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductNine.vue"
export default component.exports